import { CustomColormapLegend } from "@/components/organisms/CustomColormapLegend/CustomColormapLegend";
import type { ColormapCreate } from "@mm/metx-workbench.meteomatics.com";
import "./CustomColormapsManager.scss";

export function CustomColormapsLegendPreview({ colormap }: { colormap: ColormapCreate }) {
  return (
    <div className="legend-preview">
      <CustomColormapLegend
        colormap={colormap}
        barHeight={310}
        barWidth={10}
        resizable={false}
        panelPadding={{ x: 0, y: 10 }}
      />
    </div>
  );
}
